import * as React from "react";
import { Text } from "../../../ui/components/Text";
import { Modal } from "../../../ui/components/Modal";
import { Callout } from "../../../ui/components/Callout";
import { PhoneSetupStep } from "../user-setup/PhoneSetupStep";
import { RemovePhoneContent } from "./RemovePhoneContent";
import { useAuth } from "../../lib/auth/hooks";

export type VerifyPhoneModalMode = "verify" | "remove";

export interface VerifyPhoneModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  mode: VerifyPhoneModalMode;
  onClose?: () => void;
}

export function VerifyPhoneModal({ open, setOpen, mode, onClose }: VerifyPhoneModalProps) {
  const { user, accessToken, refreshUser } = useAuth();
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);
  const wasOpenRef = React.useRef(false);

  const token =
    accessToken ??
    (typeof localStorage !== "undefined" ? localStorage.getItem("access_token") : null);

  React.useEffect(() => {
    if (open) return;
    setError(null);
    setLoading(false);
  }, [open]);

  React.useEffect(() => {
    if (wasOpenRef.current && !open) {
      onClose?.();
    }
    wasOpenRef.current = open;
  }, [open, onClose]);

  const handleRemoved = () => {
    setOpen(false);
  };

  const title = mode === "remove" ? "Remove phone number" : "Verify your phone";

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      minWidth="520px"
      maxWidth="520px"
      minHeight="auto"
      maxHeight="85vh"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
          padding: "8px 4px 4px",
        }}
      >
        <Text level="h3" weight="bold">
          {title}
        </Text>

        {error && <Callout variant="error">{error}</Callout>}

        {mode === "remove" ? (
          <RemovePhoneContent
            token={token}
            onRefreshUser={refreshUser}
            onError={setError}
            onRemoved={handleRemoved}
          />
        ) : (
          <PhoneSetupStep
            standalone
            active={open}
            user={user}
            token={token}
            loading={loading}
            onError={setError}
            onLoading={setLoading}
            onRefreshUser={refreshUser}
          />
        )}
      </div>
    </Modal>
  );
}
